module.exports = __webpack_public_path__ + "img/3_170.b4d29544.png";